import { useMutation, useQueryClient } from "@tanstack/react-query";
import { affiliateLinkKeys } from "Api/Queries/Lead/useGetAffiliateLink";
import {
  type SetDefaultAffiliateLicenseRequest,
  putLeadsAffiliateMerchantLicense,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

export const useSetDefaultAffiliateLicenseMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: SetDefaultAffiliateLicenseRequest) =>
        putLeadsAffiliateMerchantLicense(data),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: affiliateLinkKeys.byRole("Merchant"),
      });
    },
    onError: () => toast.error(t(Resources.Common.SaveError)),
  });
};
